import Header from '../utils/Header';
import CustomSearchBar from '../utils/CustomSearchBar';
import BlogCard from './BlogCard';
import BlogsAPI from '../Apis/BlogsAPI';
import './BlogHome.scss';
import Carousel from '../utils/Carousel';
import toList from '../utils/ComponentUtil';


function BlogHome() {
    const {data} = BlogsAPI.fetchBlogs();
    const blogs = data;
    return (
        <div className='wrapper'>
            <Header title='Blogs' subTitle='Read some intresting blogs and know what’s new in this world'></Header>
            <CustomSearchBar placeholder='Search Keyword'></CustomSearchBar>
            <div className='top-content'>
                <BlogCard {...blogs[0]}></BlogCard>
            </div>
            <div className='recent-blogs-wrp'>
                <div className='leftContent'>
                    <BlogCard {...blogs[1]}></BlogCard>
                </div>
                <div className='recent-blogs'>
                    <div className='title'>Recent blogs</div>
                    <div className='blogs-container'>
                        <BlogCard {...blogs[2]} noDesc={true}></BlogCard>
                        <BlogCard {...blogs[3]} noDesc={true}></BlogCard>
                        <BlogCard {...blogs[4]} noDesc={true}></BlogCard>
                        <BlogCard {...blogs[5]} noDesc={true}></BlogCard>
                    </div>
                </div>
            </div>
            <div className='category-blogs-wrp'>
                <div className='title'>Technology</div>
                <Carousel numberOfCards={2} tabCards={1} showDots={true}
                    cards={toList([blogs[6], blogs[7], blogs[6], blogs[7]], BlogCard)}
                ></Carousel>
            </div>
            <div className='category-blogs-wrp'>
                <div className='title'>Marketing</div>
                <Carousel numberOfCards={2} tabCards={1} showDots={true}
                    cards={toList([blogs[8], blogs[9], blogs[8], blogs[9]], BlogCard)}
                ></Carousel>
            </div>
            <div className='category-blogs-wrp'>
                <div className='title'>Business</div>
                <Carousel numberOfCards={2} tabCards={1} showDots={true}
                    cards={toList([blogs[10], blogs[11], blogs[10], blogs[11]], BlogCard)}
                ></Carousel>
            </div>
        </div>
    );
}

export default BlogHome;